import type { RecordModel } from 'pocketbase';
import { pb } from './pocketbase';
import { apiRequest } from './client';
import { realtimeSubscribe } from './realtime';

export type DeploymentRecord = RecordModel & {
  device?: string;
  layout?: string;
  layout_version?: number;
  version?: number;
  status?: string;
  deployed_at?: string;
  expand?: {
    device?: { name?: string };
    layout?: { name?: string };
  };
};

export type LayoutRecord = RecordModel & {
  name?: string;
  status?: string;
  version?: number;
  preset?: string;
};

export type DeployResult = { deployment_id: string; version: number; etag: string };

export async function listDeployments(deviceId?: string): Promise<DeploymentRecord[]> {
  const records = await pb.collection('deployments').getFullList({
    sort: '-version',
    filter: deviceId ? `device = "${deviceId}"` : '',
    expand: 'device,layout'
  });
  return records as DeploymentRecord[];
}

export function subscribeDeployments(reload: () => void): () => void {
  let active = true;
  const stop = realtimeSubscribe('deployments', () => {
    if (active) reload();
  });
  return () => {
    active = false;
    stop();
  };
}

export async function listPublishedLayouts(): Promise<LayoutRecord[]> {
  const records = await pb.collection('layouts').getFullList({ sort: '-created', filter: 'status = "published"' });
  return records as LayoutRecord[];
}

export async function deploy(deviceId: string, layoutId: string): Promise<DeployResult> {
  return apiRequest<DeployResult>('/deployments', { method: 'POST', body: { device_id: deviceId, layout_id: layoutId } });
}

export async function rollback(deploymentId: string): Promise<DeployResult> {
  return apiRequest<DeployResult>(`/deployments/${deploymentId}/rollback`, { method: 'POST' });
}
